<div *ngIf="salesLeadItems else sloading">

  <app-confirm-delete-product-part [(display)]="confirmDeleteOn"
                                   [typeConfirmation]="typeDeleteConfirmation"
                                   [confirmText]="confirmText"
                                   (done)="onDeleteConfirmation($event)"></app-confirm-delete-product-part>

  <p-table #ptable4 [value]="salesLeadItems"
           [rows]="10"
           [rowsPerPageOptions]="[10,25,50]"
           [showCurrentPageReport]="paginator"
           [totalRecords]="totalSalesLeadItems"
           [paginator]="paginator"
           [loading]="loading"
           currentPageReportTemplate="Показано от {first} до {last} из {totalRecords} документов"
           sortMode="single"
           sortField="DOCDATE"
           sortOrder="-1"
           dataKey="DRID"
           selectionMode="single"
           [(selection)]="selectedSalesLeadItem"
           editMode="row"
           [resizableColumns]="true"
           [rowHover]="true"
           rowExpandMode="single"
           styleClass="p-datatable p-datatable-gridlines p-datatable-striped">

    <ng-template pTemplate="caption" *ngIf="showHeader">
      <div class="grid vertical-container">
        <div class="col align-self-end">
          <div class="grid justify-content-end">
            <p-button label="Обновить" icon="pi pi-refresh" (onClick)="reloadDocContent($event)" styleClass="p-button-success mt-2 mr-2" [disabled]="editMode"
                      pTooltip="Обновить содержимое таблицы" tooltipPosition="top"></p-button>
            <p-button label="XLSX" icon="pi  pi-file-excel" styleClass="p-button-info mt-2 mr-2" (onClick)="onExportData()"
                      pTooltip="Экспортировать содержимое документа" tooltipPosition="top" [disabled]="noItems || editMode"></p-button>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template pTemplate="header">
      <tr>
        <th style="width: 8rem" *ngIf="allowEditControls">
          <div class="col align-self-start">
            <p-selectButton [options]="showFilterOptions" [(ngModel)]="showFilterValue" multiple="multiple" optionValue="value" optionDisabled="disabled" optionLabel="icon"
                            pTooltip="Показывать фильтр по полям таблицы" tooltipPosition="top">
              <ng-template let-item pTemplate>
                <i [class]="item.icon"></i>
              </ng-template>
            </p-selectButton>
          </div>
        </th>
        <th pResizableColumn pSortableColumn="DRNOTE" style="width: 10%">Комментарий <p-sortIcon field="DRNOTE"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="DOCNAME" style="width: auto">Документ <p-sortIcon field="DOCNAME"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="DOCNUMBER" style="width: auto">Документ <p-sortIcon field="DOCNUMBER"></p-sortIcon></th>
        <th *ngIf="!editMode" pResizableColumn pSortableColumn="DOCDATE" style="width: 5%">Дата <p-sortIcon field="DOCDATE"></p-sortIcon></th>
        <th *ngIf="!editMode" pResizableColumn pSortableColumn="LOCALCOMP" style="width: 10%">Продавец <p-sortIcon field="LOCALCOMP"></p-sortIcon></th>
        <th *ngIf="!editMode" pResizableColumn pSortableColumn="AUTHOR" style="width: 6%">Автор <p-sortIcon field="AUTHOR"></p-sortIcon></th>
        <th *ngIf="!editMode" pResizableColumn pSortableColumn="CLIENTSNAME" style="width: auto">Заказчик <p-sortIcon field="CLIENTSNAME"></p-sortIcon></th>
        <th *ngIf="!editMode" pResizableColumn pSortableColumn="DOCSUM" style="width: 6%">Сумма <p-sortIcon field="DOCSUM"></p-sortIcon></th>
        <th *ngIf="!editMode" pResizableColumn pSortableColumn="PAYDSUM" style="width: 6%">Оплачено <p-sortIcon field="PAYDSUM"></p-sortIcon></th>
        <th *ngIf="!editMode" pResizableColumn pSortableColumn="SHIPSUM" style="width: 6%">Отгружено <p-sortIcon field="SHIPSUM"></p-sortIcon></th>
        <th *ngIf="!editMode" pResizableColumn pSortableColumn="DOCNOTE1" style="width: 10%">Пр. продавца <p-sortIcon field="DOCNOTE1"></p-sortIcon></th>
        <th *ngIf="!editMode" pResizableColumn pSortableColumn="DOCNOTE2" style="width: 10%">Пр. покупателя <p-sortIcon field="DOCNOTE2"></p-sortIcon></th>
      </tr>
      <tr *ngIf="showFilter">
        <th pResizableColumn style="width: 8rem" *ngIf="allowEditControls">Фильтр =></th>
        <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf4['DRNOTE']" (input)="ptable4.filter($event.target.value, 'DRNOTE', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
        <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf4['DOCNAME']" (input)="ptable4.filter($event.target.value, 'DOCNAME', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
        <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf4['DOCNUMBER']" (input)="ptable4.filter($event.target.value, 'DOCNUMBER', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
        <th *ngIf="!editMode" pResizableColumn><input pInputText type="text" [(ngModel)]="cf4['DOCDATE']" (input)="ptable4.filter($event.target.value, 'DOCDATE', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
        <th *ngIf="!editMode" pResizableColumn><input pInputText type="text" [(ngModel)]="cf4['LOCALCOMP']" (input)="ptable4.filter($event.target.value, 'LOCALCOMP', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
        <th *ngIf="!editMode" pResizableColumn><input pInputText type="text" [(ngModel)]="cf4['AUTHOR']" (input)="ptable4.filter($event.target.value, 'AUTHOR', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
        <th *ngIf="!editMode" pResizableColumn><input pInputText type="text" [(ngModel)]="cf4['CLIENTSNAME']" (input)="ptable4.filter($event.target.value, 'CLIENTSNAME', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
        <th *ngIf="!editMode" pResizableColumn><input pInputText type="text" [(ngModel)]="cf4['DOCSUM']" (input)="ptable4.filter($event.target.value, 'DOCSUM', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
        <th *ngIf="!editMode" pResizableColumn><input pInputText type="text" [(ngModel)]="cf4['PAYDSUM']" (input)="ptable4.filter($event.target.value, 'PAYDSUM', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
        <th *ngIf="!editMode" pResizableColumn><input pInputText type="text" [(ngModel)]="cf4['SHIPSUM']" (input)="ptable4.filter($event.target.value, 'SHIPSUM', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
        <th *ngIf="!editMode" pResizableColumn><input pInputText type="text" [(ngModel)]="cf4['DOCNOTE1']" (input)="ptable4.filter($event.target.value, 'DOCNOTE1', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
        <th *ngIf="!editMode" pResizableColumn><input pInputText type="text" [(ngModel)]="cf4['DOCNOTE2']" (input)="ptable4.filter($event.target.value, 'DOCNOTE2', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-salesLeadItem let-expanded="expanded" let-editing="editing" let-ri="rowIndex">
      <tr [pSelectableRow]="salesLeadItem"
          [pEditableRow]="salesLeadItem"
          [class.futuredocs]="salesLeadItem.fd"
          [class.grayout]="salesLeadItem.go"
          [class.underline]="salesLeadItem.ps"
          [class.strikeout]="salesLeadItem.fs"
          [class.partiallypaiddoc]="salesLeadItem.pp"
          [class.notpaiddoc]="salesLeadItem.np"
          [class.fullypaiddoc]="salesLeadItem.fp"
          [class.todaydocuments]="salesLeadItem.td"
          [class.proformadoc]="(salesLeadItem.DOCTYPE == 12)"
          [class.inorderdoc]="(salesLeadItem.DOCTYPE == 2)"
          [class.banktransferdoc]="(salesLeadItem.DOCTYPE == 9)"
          [class.purchorderdoc]="(salesLeadItem.DOCTYPE == 10)"
          [class.yellowdoc]="(salesLeadItem.DOCTYPE == 14)"
          [class.specdoc]="(salesLeadItem.DOCTYPE == 7)"
          [class.shiporderdoc]="(salesLeadItem.DOCTYPE == 4)"
          [class.invoicedoc]="(salesLeadItem.DOCTYPE == 1)">
        <td *ngIf="allowEditControls">
          <button *ngIf="!editing && !editMode"
                  pButton pRipple type="button" [pRowToggler]="salesLeadItem" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" class="p-button-text p-button-rounded p-button-plain"></button>

          <button *ngIf="!editing && !editMode && !expanded"
                  pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil" (click)="onDiRowEditInit(salesLeadItem)" class="p-button-rounded p-button-text"></button>

          <button *ngIf="editing" [disabled]="!allowSave(salesLeadItem, ri)"
                  pButton pRipple type="button" pSaveEditableRow icon="pi pi-save" (click)="onDiRowEditSave(salesLeadItem)" class="p-button-rounded p-button-text p-button-success mr-2"></button>

          <button *ngIf="editing"
                  pButton pRipple type="button" pCancelEditableRow icon="pi pi-times" (click)="onDiRowEditCancel(salesLeadItem, ri)" class="p-button-rounded p-button-text p-button-danger"></button>
        </td>

        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="text" [(ngModel)]="salesLeadItem.DRNOTE" [style]="{'width':'100%'}" (keydown)="$event.stopPropagation()">
            </ng-template>
            <ng-template pTemplate="output">
              <input pInputText type="text" [(ngModel)]="salesLeadItem.DRNOTE" [style]="{'width':'100%'}" readonly alt="{{salesLeadItem.DRNOTE}}">
            </ng-template>
          </p-cellEditor>
        </td>

        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{salesLeadItem.DOCNAME}}</td>

        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <app-documentselector showLabel="false" placeholder="Выбрать документ..." [documentId]="salesLeadItem.DOCID" (selectedDocument)="onDocumentSelected($event, salesLeadItem)" [style]="{'width':'100%'}"></app-documentselector>
            </ng-template>
            <ng-template pTemplate="output">
              <div class="align-self-baseline" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
                <a [routerLink]="['/edit-document', salesLeadItem.DOCTYPEID, salesLeadItem.DOCID]">{{salesLeadItem.DOCNUMBER}}</a>
              </div>
            </ng-template>
          </p-cellEditor>
        </td>

        <td *ngIf="!editing && !editMode" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{salesLeadItem.DOCDATE  | date:'dd.MM.yyyy'}}</td>
        <td *ngIf="!editing && !editMode" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{salesLeadItem.LOCALCOMP}}</td>
        <td *ngIf="!editing && !editMode" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{salesLeadItem.AUTHOR}}</td>
        <td *ngIf="!editing && !editMode" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"><a [routerLink]="['/edit-client', salesLeadItem.DOCCLIENTSID]">{{salesLeadItem.CLIENTSNAME}}</a></td>
        <td *ngIf="!editing && !editMode" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{salesLeadItem.DOCSUM | number:'1.2-2' }}</td>
        <td *ngIf="!editing && !editMode" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{salesLeadItem.PAYDSUM | number:'1.2-2' }}</td>
        <td *ngIf="!editing && !editMode" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{salesLeadItem.SHIPSUM | number:'1.2-2' }}</td>
        <td *ngIf="!editing && !editMode" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{salesLeadItem.DOCNOTE1}}</td>
        <td *ngIf="!editing && !editMode" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{salesLeadItem.DOCNOTE2}}</td>
      </tr>
    </ng-template>

    <ng-template pTemplate="rowexpansion" let-salesLeadItem>
      <tr>
        <td colspan="13">
          <div class="p-p-2">
            <app-document-content-table [selectedDocumentId]="salesLeadItem.DOCID"></app-document-content-table>
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="summary">
      <div class="grid" *ngIf="allowEditControls">
        <div class="col">
          <div class="grid formgrid p-jc-start">
            <p-button label="Добавить строку" icon="pi pi-plus" (onClick)="onAddRow($event)" styleClass="p-button-success ml-2 mt-2 mr-2" [disabled]="editMode"
                      pTooltip="Добавить новую строку" tooltipPosition="top"></p-button>
          </div>
        </div>
        <div class="col">
          <div class="grid formgrid justify-content-end">
            <p-button label="Удалить все строки" icon="pi pi-trash" (onClick)="onRemoveAllRow($event)" styleClass="p-button-danger mt-2 mr-2" [disabled]="editMode || noItems"
                      pTooltip="Убрать выбранную строку" tooltipPosition="top"></p-button>
            <p-button label="Удалить строку" icon="pi pi-minus" (onClick)="onRemoveRow($event)" styleClass="p-button-warning mt-2 mr-2" [disabled]="editMode || !selection"
                      pTooltip="Убрать выбранную строку" tooltipPosition="top"></p-button>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="13">Записей не обнаружено</td>
      </tr>
    </ng-template>
  </p-table>
</div>
<ng-template #sloading>
  <p>Содержимое загружается...</p>
</ng-template>
